import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import SuggandActred from "./SuggandActred";
import CustomLoader from "../static/CustomLoader.js";
import { getDropDownVal } from "../dropdownUtils.js";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const SuggandactrefListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [loading, setLoading] = useState(false);
  const [suggandactrefs, setSuggandActrefs] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const [actrefData, setActrefData] = useState([]);
  const [sugesttiondata, setSuggestionData] = useState([]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const expectedHeaders = ["id", "code", "type", "header", "name", "content"];

  const columns = [
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const typeOption = typeData.find(
          (option) => option.value === params.value,
        );
        return typeOption ? typeOption.label : params.value;
      },
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "content",
      headerName: "Content",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  useEffect(() => {
    const fetchTypeOptions = () => {
      try {
        const response = getDropDownVal("MTP");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setTypeData(actOption);
      } catch (error) {
        console.log("error");
      }
    };
    fetchTypeOptions();
  }, []);

  useEffect(() => {
    const fetchActrefOptions = () => {
      try {
        const response = getDropDownVal("ACTF");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setActrefData(actOption);
      } catch (error) {
        console.log("error");
      }
    };
    fetchActrefOptions();
  }, []);

  useEffect(() => {
    const fetchSuggestionOptions = () => {
      try {
        const response = getDropDownVal("SUGG");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setSuggestionData(actOption);
      } catch (error) {
        console.log("error");
      }
    };
    fetchSuggestionOptions();
  }, []);

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "suggandactref", { headers });
      setSuggandActrefs(response.data);
      setFilterData(response.data);
      setRefresh(false);
      setSelectedData("");
    } catch (error) {
      console.log("error " + error);
      setSuggandActrefs([]);
    } finally {
      setLoading(false);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setSuggandActrefs(searchdata);
    } else {
      setSuggandActrefs(filterData);
    }

    setSerach(getSearch);
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);
          try {
            await axios
              .delete(apiUrl + "suggandactref/" + selectedData[0], { headers })
              .then(() => {
                toast.success("Record removed successfully.");
                fetchData();
              });
          } catch (error) {
            console.error("Error deleting record:", error);
          } finally {
            setLoading(false);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  const exportToExcel = (data, filename = "Suggestion_Act_Reference.xlsx") => {
    const ws = XLSX.utils.json_to_sheet(data, {
      header: expectedHeaders,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(file, filename);
  };

  const importFromExcel = (file, onValidData, onError) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const wb = XLSX.read(e.target.result, {
        type: "binary",
      });

      const sheet = wb.Sheets[wb.SheetNames[0]];

      const json = XLSX.utils.sheet_to_json(sheet, {
        defval: "",
      });

      const headers1 = Object.keys(json[0] || {});

      const isValid = expectedHeaders.every((h) => headers1.includes(h));

      if (!isValid) {
        onError("Invalid Excel Format. Please use the correct column headers.");
      } else {
        onValidData(json);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleSubmitWithImportedData = async (importedData) => {
    if (importedData.length > 0) {
      try {
        setLoading(true);

        const transformedData = importedData.map((item) => ({
          ...item,
          id: 0,
          code: 0,
        }));

        const response = await axios.post(
          apiUrl + "suggandactref/multipleSave",
          transformedData,
          { headers },
        );

        if (response.data.cd === 1) {
          toast.warning("Failed to Import Data.");
          setRefresh(true);
        } else {
          toast.success("Imported data saved successfully.");
          setRefresh(true);
        }
      } catch (error) {
        console.error("Error during import:", error);
      } finally {
        setLoading(false);
      }
    } else {
      toast.warning("No data to import.");
    }
  };

  const handleExcelImport = (event) => {
    const file = event.target.files[0];

    if (file) {
      importFromExcel(
        file,
        (validData) => {
          handleSubmitWithImportedData(validData);
          toast.success("Valid Excel file imported.");
        },
        (errorMsg) => {
          toast.error(errorMsg);
        },
      );
    }

    event.target.value = null;
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Suggestion/Act Reference"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Suggestion/Act Reference"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Suggestion/Act Reference"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Export Suggestion/Act Reference data"
                onClick={() => exportToExcel(suggandactrefs)}
                disabled={loading}
              >
                Export
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Import Suggestion/Act Reference data"
                component="label"
                icon={<UploadFileOutlinedIcon />}
                disabled={loading}
              >
                Import Data
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  hidden
                  onChange={handleExcelImport}
                />
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            suggandactrefs !== null &&
            suggandactrefs.length > 0 &&
            Object.keys(suggandactrefs[0]).length !== 0 &&
            suggandactrefs
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Suggestion / Act Reference"
        maxWidth="md"
      >
        <SuggandActred
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          typeData={typeData}
          sugesttiondata={sugesttiondata}
          actrefData={actrefData}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Suggestion / Act Reference"
        maxWidth="md"
      >
        <SuggandActred
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          typeData={typeData}
          sugesttiondata={sugesttiondata}
          actrefData={actrefData}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default SuggandactrefListing;
